import * as author from "./author-actions";
import { ActionType, getType } from "typesafe-actions";
import update from "immutability-helper";
import { IAuthor } from "~/types/author";

export type AuthorAction = ActionType<typeof author>;

export interface AuthorSearchParams {
    searchString?: string;
    complexQuery?: string;
    page?: number;
    loadMorePageSize?: number;
}

export interface AuthorState {
    readonly isPending: boolean;
    readonly authorParams: AuthorSearchParams;
    readonly authors?: IAuthor[]; // TO-DO: Use different type ...
    readonly totalCount?: number;
    readonly totalCountLabel?: string;
    readonly displayedOutOfTotalLabel?: string;
}

export const initialState: AuthorState = {
    isPending: false,
    authorParams: {}
};

const authorReducer = (state: AuthorState = initialState, action: AuthorAction) => {
    switch (action.type) {
        case getType(author.authorSearchRequest):
            return update(state, {
                isPending: { $set: true }
            });
        case getType(author.authorSearchSuccess):
            return update(state, {
                isPending: { $set: false },
                authors:
                    action.payload.page !== 0
                        ? { $push: action.payload.authors }
                        : { $set: action.payload.authors },
                displayedOutOfTotalLabel: { $set: action.payload.displayedOutOfTotalLabel },
                totalCount: { $set: action.payload.totalCount },
                totalCountLabel: { $set: action.payload.totalCountLabel }
            });
        case getType(author.authorSearchError):
            return update(state, {
                isPending: { $set: false }
            });
        case getType(author.populateAuthors):
            return update(state, {
                authors: { $set: action.payload.authors }
            });
        case getType(author.updateAuthorParams):
            return update(state, {
                authorParams: { $merge: action.payload }
            });
        default:
            return state;
    }
};

export default authorReducer;
